import { handler as customerQueryHandler } from "./customer.query";

// NOTE: The components in which these queries and mutations are
// used are noted next to the mock handlers below
export const customerHandlers = [
  customerQueryHandler, // CustomerContext.tsx
];
